// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import TabletTwoToneSvg from "@fishx/icons-svg/es/asn/TabletTwoTone";
import FishxIcon from '../components/FishxIcon';

var TabletTwoTone = function TabletTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: TabletTwoToneSvg
  }));
};

TabletTwoTone.displayName = 'TabletTwoTone';
export default React.forwardRef(TabletTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/TabletTwoTone.js
// module id = 4227
// module chunks = 0